import PropTypes from 'prop-types';
import { forwardRef, useCallback } from 'react';

import AutosuggestTextarea from 'mastodon/components/autosuggest_textarea';
import { useBotCommandsFor } from 'mastodon/utils/bot_commands_store';

/**
 * The compose textarea, with suggestions for the commands of the bots the
 * post mentions (e.g. `@dicebot [fortune/today]`)
 */
export const BotCommandTextarea = forwardRef(({ value, onChange, ...props }, ref) => {
  const botCommands = useBotCommandsFor(value ?? '');

  const handleInsert = useCallback((text, caret) => {
    onChange({ target: { value: text } });

    // Put the caret after the inserted command once the text is updated
    requestAnimationFrame(() => {
      ref.current?.setSelectionRange(caret, caret);
    });
  }, [onChange, ref]);

  return (
    <AutosuggestTextarea
      {...props}
      ref={ref}
      value={value}
      onChange={onChange}
      botCommands={botCommands}
      onBotCommandInsert={handleInsert}
    />
  );
});

BotCommandTextarea.displayName = 'BotCommandTextarea';

BotCommandTextarea.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
